import React, { useEffect, useState } from "react";
import Popup from "./Popup";
import { Button, notification} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { apiRequest } from "util/services";
import styles from './style.module.scss'
const PopupSequence = ({setSelectedConfiguration, setIsLoading}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false)
  const [resetPopup, setResetPopup] = useState(false)
  const [continueButtonClicked, setContinueButtonClicked] = useState(false)
  const [selectCategoriesButtonClicked, setSelectCategoriesButtonClicked] = useState(false)
  const [groups, setGroups] = useState([])
  const [selectedGroups, setSelectedGroups] = useState([])
  const [dashboards, setDashboards] = useState([])
  const [selectedDashboards, setSelectedDashboards] = useState([])
  const [categories, setCategories] = useState([])
  const [selectedCategories, setSelectedCategories] = useState([])
  const requestDataForDashboards = {
    "groupIds":selectedGroups?.map((group)=>group.groupId),
  }
  const requestDataForCategories = {
    "dashboard_ids":selectedDashboards?.map((dashboard)=> dashboard.dashboardId)
  }
  const requestDataForSaveSources = {
    "groupIds":selectedGroups?.map((group)=>group.groupId),
    "dashboardIds":selectedDashboards?.map((dashboard)=>dashboard.dashboardId),
    "categoryIds":selectedCategories?.map((category)=>category.categoryId)
  }
  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setContinueButtonClicked(false);
    setSelectCategoriesButtonClicked(false);
  }
  useEffect(() => {
    if (isPopupOpen) {
      (async () => {
        const apiResponse = await apiRequest("industry_analysis/groups", "GET",null, true)
        setIsLoading(true)
        if (apiResponse?.data) {
          setGroups(apiResponse.data);
          setIsLoading(false)
        }
        else{
          notification.error({
            message: `${apiResponse?.error}`,
          })
          setIsLoading(false)
        }
      })();
    } else if (continueButtonClicked) {
      (async () => {
        const apiResponse = await apiRequest("industry_analysis/dashboards", "POST", requestDataForDashboards, true);
        setIsLoading(true)
        if (apiResponse?.data) {
          setDashboards(apiResponse?.data);
          setIsLoading(false)
        }
        else{
          notification.error({
            message: `${apiResponse?.error}`,
          })
          setIsLoading(false)
        }
      })();
    } else if (selectCategoriesButtonClicked) {
      (async () => {
        const apiResponse = await apiRequest("industry_analysis/categories", "POST", requestDataForCategories, true);
        setIsLoading(true)
        if (apiResponse?.data) {
          setCategories(apiResponse?.data);
          setIsLoading(false)
        }
        else{
          notification.error({
            message: `${apiResponse?.error}`,
          })
          setIsLoading(false)
        }
      })();
    }
  }, [isPopupOpen, continueButtonClicked, selectCategoriesButtonClicked]);
  const handleSaveSources = async () =>{
    setSelectedConfiguration(requestDataForSaveSources)
    const apiResponse = await apiRequest('industry_analysis/saveSources','POST',requestDataForSaveSources, true)
    setIsLoading(true)
    if(apiResponse?.success){
      return
    }
    else {
      notification.error({
        message: `${apiResponse?.error}`,
      })
      setIsLoading(false)
    }
  }
  return (
    <div>
      <Button className={styles.StartButton} onClick={() => {setIsPopupOpen(true);setResetPopup(true)}}><PlusOutlined/><span>Start</span></Button>
      {isPopupOpen && (
        <Popup 
          open={isPopupOpen} 
          onClose={handleClosePopup} 
          data={groups} 
          dataType={"Groups"} 
          setContinueButtonClicked={setContinueButtonClicked} 
          selectedGroups={selectedGroups} 
          setSelectedGroups={setSelectedGroups} 
          resetPopup={resetPopup} 
        />
      )}
      {(continueButtonClicked) && (
        <Popup 
          open={continueButtonClicked} 
          onClose={handleClosePopup} 
          data={dashboards} 
          dataType={"Dashboards"} 
          setSelectCategoriesButtonClicked={setSelectCategoriesButtonClicked} 
          selectedDashboards={selectedDashboards} 
          setSelectedDashboards={setSelectedDashboards} 
          resetPopup={resetPopup}
        />
      )}
      {(selectCategoriesButtonClicked) && (
        <Popup 
          open={selectCategoriesButtonClicked} 
          onClose={handleClosePopup} data={categories} 
          onSave={handleSaveSources}
          dataType={"Categories"}
          selectedCategories={selectedCategories} 
          setSelectedCategories={setSelectedCategories} 
          resetPopup={resetPopup} />
      )}
    </div>
  );
};

export default PopupSequence
